var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_281_13089)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EADDFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.7602 31H25.2402C28.0002 31 29.1002 29.31 29.2302 27.25L29.7502 18.99C29.8902 16.83 28.1702 15 26.0002 15C25.3902 15 24.8302 14.65 24.5502 14.11L23.8302 12.66C23.3702 11.75 22.1702 11 21.1502 11H18.8602C17.8302 11 16.6302 11.75 16.1702 12.66L15.4502 14.11C15.1702 14.65 14.6102 15 14.0002 15C11.8302 15 10.1102 16.83 10.2502 18.99L10.7702 27.25C10.8902 29.31 12.0002 31 14.7602 31Z",
    fill: "#6A639C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17.75H18.5C18.09 17.75 17.75 17.41 17.75 17C17.75 16.59 18.09 16.25 18.5 16.25H21.5C21.91 16.25 22.25 16.59 22.25 17C22.25 17.41 21.91 17.75 21.5 17.75Z",
    fill: "#6A639C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 27.13C21.8668 27.13 23.3801 25.6167 23.3801 23.75C23.3801 21.8833 21.8668 20.37 20.0001 20.37C18.1334 20.37 16.6201 21.8833 16.6201 23.75C16.6201 25.6167 18.1334 27.13 20.0001 27.13Z",
    fill: "#6A639C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_281_13089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d3fc5560750bb076e1597933ea3c580c.svg";
export { ForwardRef as ReactComponent };